module.exports = __webpack_public_path__ + "img/chuangketie.c21faf4f.jpg";